import jsPDF from "jspdf";
import { drawProHeader, drawProFooter, getSettingsCached } from "./pdfHeader";

export async function generatePrescriptionPDF(rx) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 48;

  const settings = rx._settings || (await getSettingsCached());
  const doctor = rx._doctor || {
    name: rx.doctor_name,
    specialty: rx.doctor_specialty,
    license_number: rx.doctor_license,
  };

  let y = await drawProHeader(doc, {
    docTitle: "RECETA MÉDICA PRIVADA",
    docSubtitle: "Compatible REMPE",
    settings, doctor,
  });
  y += 14;

  // Code/date row
  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139);
  doc.text(`Código: ${rx.code}`, margin, y);
  doc.text(new Date(rx.created_at).toLocaleString(), W - margin, y, { align: "right" });
  y += 14;
  doc.text(`Verificación: ${rx.verification_code || "-"}`, margin, y);
  if (rx.valid_until) doc.text(`Válida hasta: ${rx.valid_until}`, W - margin, y, { align: "right" });
  y += 18;

  doc.setDrawColor(226, 232, 240);
  doc.line(margin, y, W - margin, y); y += 18;

  // Patient block (boxed)
  doc.setFillColor(248, 250, 252);
  doc.roundedRect(margin, y - 4, W - 2 * margin, 56, 6, 6, "F");
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text("PACIENTE", margin + 12, y + 10);
  doc.setFontSize(12);
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.text(rx.patient_name || "-", margin + 12, y + 26);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(71, 85, 105);
  if (rx.patient_nif) doc.text(`DNI/NIE: ${rx.patient_nif}`, margin + 12, y + 42);
  if (rx.doctor_rempe) doc.text(`Código REMPE: ${rx.doctor_rempe}`, W - margin - 12, y + 42, { align: "right" });
  y += 70;

  // Diagnosis
  doc.setFontSize(11);
  doc.setTextColor(15, 118, 110);
  doc.setFont("helvetica", "bold");
  doc.text("DIAGNÓSTICO", margin, y);
  doc.setFont("helvetica", "normal");
  y += 14;
  doc.setFontSize(11);
  doc.setTextColor(15, 23, 42);
  const diag = doc.splitTextToSize(rx.diagnosis || "-", W - 2 * margin);
  doc.text(diag, margin, y); y += diag.length * 14 + 14;

  // Medications
  doc.setFontSize(11);
  doc.setTextColor(15, 118, 110);
  doc.setFont("helvetica", "bold");
  doc.text("MEDICAMENTOS PRESCRITOS", margin, y);
  doc.setFont("helvetica", "normal");
  y += 16;
  (rx.medications || []).forEach((m, i) => {
    if (y > 660) { doc.addPage(); y = 60; }
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(226, 232, 240);
    doc.roundedRect(margin, y - 4, W - 2 * margin, 38, 4, 4, "S");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.text(`${i + 1}. ${m.name}`, margin + 10, y + 10);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(71, 85, 105);
    doc.text(`${m.dosage}  ·  ${m.frequency}  ·  ${m.duration}`, margin + 10, y + 24);
    if (m.instructions) {
      y += 38;
      const ins = doc.splitTextToSize(`Indicaciones: ${m.instructions}`, W - 2 * margin - 16);
      doc.setFontSize(9);
      doc.setTextColor(100, 116, 139);
      doc.text(ins, margin + 10, y); y += ins.length * 11 + 4;
    } else {
      y += 42;
    }
  });

  if (rx.notes) {
    if (y > 640) { doc.addPage(); y = 60; }
    y += 6;
    doc.setFontSize(11);
    doc.setTextColor(15, 118, 110);
    doc.setFont("helvetica", "bold");
    doc.text("NOTAS", margin, y);
    doc.setFont("helvetica", "normal");
    y += 14;
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    const nt = doc.splitTextToSize(rx.notes, W - 2 * margin);
    doc.text(nt, margin, y); y += nt.length * 14;
  }

  // Footer with QR + signature
  const verifyUrl = `${window.location.origin}/verify/${rx.code}?v=${rx.verification_code || ""}`;
  await drawProFooter(doc, {
    settings, doctor,
    qrUrl: verifyUrl,
    qrLabel: "Verificar receta",
    sigLabel: "Firma y sello del profesional",
    signature: rx.signature,
  });

  doc.save(`receta-${rx.code}.pdf`);
}
